import {Component, effect, inject, input, output, signal, ChangeDetectionStrategy} from "@angular/core"
import {CM_LOGGER_AR} from "@app/common/services/logging"
import {LoadingSpinnerComponent} from "@common/components/progress"
import {MenuDialogComponent} from "@common/components/dialogs/menu-dialog/menu-dialog.component"
import {toDataURL} from "qrcode"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-ar-dialog",
    templateUrl: "./ar-dialog.component.html",
    styleUrls: ["./ar-dialog.component.scss"],
    imports: [MenuDialogComponent, LoadingSpinnerComponent],
})
export class ArDialogComponent {
    private readonly logger = inject(CM_LOGGER_AR)
    readonly close = output<void>()

    readonly $desktopArUrl = input<string | null | undefined>(undefined, {alias: "desktopArUrl"})

    constructor() {
        effect(() => {
            const value = this.$desktopArUrl()
            if (!value) {
                this.$waitingForArFile.set(true)
                return
            }
            this.generateQrCode(value).then(() => {
                this.$waitingForArFile.set(false)
            })
        })
    }

    readonly $qrCode = signal("")
    readonly $waitingForArFile = signal(true)

    async generateQrCode(url: string): Promise<string | void> {
        return toDataURL(url, {errorCorrectionLevel: "high", width: 1000, margin: 4})
            .then((url: string) => this.$qrCode.set(url))
            .catch((error) => this.logger.error(error))
    }
}
